import React, { useState } from 'react';
import { useSnackbar } from 'material-ui-snackbar-provider';

import { patchRevokeSuperAdmin } from '../../../../api/usersApi';
import { ContainedButton, OutlinedButton } from '../../Buttons';
import styles from './RevokeSuperAdminModal.module.scss';
import { User } from '../../OrganizationCard';
import Modal from '../../Modal';
import { USER } from '../../../../enums';

type TDeleteUserModalProps = {
  isOpen: boolean;
  switchModal: () => void;
  user: USER;
  fetchData: () => void;
};

const RevokeSuperAdminModal: React.FC<TDeleteUserModalProps> = ({ isOpen, switchModal, user, fetchData }) => {
  const [loading, setLoading] = useState(false);
  const notification = useSnackbar();
  const onClose = () => {
    switchModal();
    setLoading(false);
  };

  const submit = async () => {
    try {
      setLoading(true);
      const res = await patchRevokeSuperAdmin(user.id);
      fetchData();
    } catch (err) {
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err.response.data.message);
      } else {
        console.log(err);
      }
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>
          <div style={{ marginBottom: '4px' }}>Are you sure you want to revoke Super Admin rights?</div>{' '}
          <div style={{ fontSize: '13px', marginLeft: '12px', marginTop: '12px' }}>
            Here is the user you selected:
            <ul style={{ filter: 'opacity(60%)' }}>
              <li style={{ marginLeft: '-12px' }}>
                {user?.username} ({user.email})
              </li>
            </ul>
          </div>
          <div style={{ fontSize: '13px', marginLeft: '12px', marginTop: '12px' }}>
            {' '}
            If user is not member of any organisation, then user will be deleted.{' '}
          </div>
        </div>
        <div className={styles.form}>
          <div className={styles.actionBtns}>
            <ContainedButton
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '32px' }}
              disabled={loading}
              onClick={submit}
            >
              <span>Revoke Super Admin Rights</span>
            </ContainedButton>

            <OutlinedButton
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '32px' }}
              disabled={loading}
              kind="default"
              onClick={onClose}
            >
              <span>Cancel</span>
            </OutlinedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RevokeSuperAdminModal;
